import { css } from "styled-components";

import { TOUCH_TARGET_HALF_SIZE } from "./ryde-layout-const";

/**
 * Grows a small control's hit area to the 44x44 the a11y rules require, without growing the
 * control itself — a 44px icon button in a dense card or a transcript row would dominate it, and
 * the success criterion measures what is clickable, not what is drawn.
 *
 * `inset: 50%` collapses the pseudo-element to a point at the centre and the negative margin
 * expands it symmetrically. Deliberately no transform: `cssjanus` flips `translateX` values, so a
 * transform-centred hit area lands on the wrong side of its control in RTL.
 *
 * Shared rather than copied. What is reusable is the pattern, not the two numbers a caller would
 * otherwise have to know how to combine.
 */
export const touchTargetCss = css`
  position: relative;

  &::after {
    content: "";
    position: absolute;
    inset: 50%;
    margin: -${TOUCH_TARGET_HALF_SIZE}px;
  }
`;
